import { styled, TablePagination, TablePaginationProps, Theme } from "@mui/material";

export const StyledPagination = styled((props: TablePaginationProps) => (
  <TablePagination {...props} />
))(
  ({
    theme: {
      palette: { custom },
      breakpoints
    }
  }) => `
    &.MuiTablePagination-root {
      color: ${custom.white.light};

      & .MuiTablePagination-selectLabel {
        margin: initial;
        display: initial;
      }

      & .MuiTablePagination-displayedRows {
        margin: initial;
      }

      & .MuiTablePagination-input {
        margin: 0 16px 0 0;
        display: inline-flex;

        ${breakpoints.up("md")} {
          margin: 0 26px 0 0;
        }

        & .MuiTablePagination-selectIcon {
          color: ${custom.white.light};
        }
      }

      & .MuiTablePagination-actions {
        margin-left: 16px;

        ${breakpoints.up("md")} {
          margin-left: 26px;
        }

        & .Mui-disabled {
          color: ${custom.white.dark};
        }
      }
    }
  `
);

export const makePaperStyles = ({ palette: { custom } }: Theme) => ({
  backgroundColor: "transparent",

  "& .MuiList-root": {
    padding: "10px 0",
    backgroundColor: custom.background,
    boxShadow: custom.shadows.navigation,
    color: custom.white.main
  },

  "&::-webkit-scrollbar": {
    width: "4px"
  },

  "&::-webkit-scrollbar-track": {
    background: custom.grey.main
  },

  "&::-webkit-scrollbar-thumb": {
    background: custom.white.light,
    borderRadius: "2px",

    "&:hover": {
      background: custom.white.main
    }
  }
});
